import React from "react";

import {DateFormatter} from "../../../services/date";
import CountryFlag from "../../../components/CountryFlag";
import {useQuotes} from "../QuotesContext";
import QuoteService from "../../../services/quotes";
import usePolling from "../../../hooks/usePolling";
import useEmailMessage from "../../Templates/useEmailMessage";

import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import Card from "@mui/material/Card";
import {CircularProgress} from "@mui/material";


const QuoteHeader = () => {
    const {selectedQuote: quote, quotePreviewDialog, quoteEmailViewerDialog, updateEmailMessage} = useQuotes();
    const {resendEmailMessage} = useEmailMessage();

    const handleResendEmail = async () => {
        await resendEmailMessage(quote.emailMessage.id, updateEmailMessage);
    }

    usePolling({
        active: quote.emailMessage?.status === QuoteService.enums.EMAIL_MESSAGE_STATUS.pending,
        callback: () => updateEmailMessage()
    });

    return <Card sx={{px: 2, py: 1}}>
        <Stack direction="row" spacing={2}>
            <Avatar sx={{bgcolor: quote.confirmed === true ? "success.main" : "secondary.main", width: 120, height: 120}}>
                <DescriptionIcon sx={{fontSize: 80}}/>
            </Avatar>
            <Stack flexGrow={1} spacing={0.5}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="h6" color="secondary">
                        Preventivo
                    </Typography>
                    <Typography color="text.primary">
                        #{quote.codeNumber}
                    </Typography>
                </Stack>
                <Typography variant="body2">
                    <CountryFlag code={quote.nationality.code}/> {quote.surname} {quote.name}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    {quote.email}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    Valido fino: {DateFormatter.shortString(quote.expiration)}
                </Typography>
                {
                    quote.emailMessage?.status=== QuoteService.enums.EMAIL_MESSAGE_STATUS.completed &&
                    <Typography variant="body2" color="success.main">
                        Email inviata correttamente
                    </Typography>
                }
                {
                    quote.emailMessage?.status=== QuoteService.enums.EMAIL_MESSAGE_STATUS.failed &&
                    <Typography variant="body2" color="error.main">
                        Email non inviata
                    </Typography>
                }
            </Stack>
        </Stack>
        <Stack direction="row" justifyContent="flex-end">
            {
                !quote.emailMessage?.status &&
                <Button onClick={() => quotePreviewDialog.open()} endIcon={<SendIcon/>}>
                    Crea email
                </Button>
            }
            {
                quote.emailMessage?.status === QuoteService.enums.EMAIL_MESSAGE_STATUS.pending &&
                <Stack direction="row" spacing={2} alignItems="center">
                    <Typography variant="body2" color="warning.main">
                        Invio email in corso
                    </Typography>
                    <CircularProgress size="14px" color="primary"/>
                </Stack>

            }
            {
                quote.emailMessage?.status === QuoteService.enums.EMAIL_MESSAGE_STATUS.completed &&
                <Button onClick={() => quoteEmailViewerDialog.open()} endIcon={<EmailIcon/>}>
                    Visualizza email inviata
                </Button>
            }
            {
                quote.emailMessage?.status === QuoteService.enums.EMAIL_MESSAGE_STATUS.failed &&
                <Button onClick={handleResendEmail} endIcon={<SendIcon/>}>
                    Invia di nuovo
                </Button>
            }
        </Stack>
    </Card>
}

export default QuoteHeader;